import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export default function GuideReader() {
  const { guideId } = useParams();
  const [guide, setGuide] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get(`/guides/${guideId}`)
      .then(r => setGuide(r.data))
      .catch(e => { toast.error(formatApiError(e.response?.data?.detail)); nav("/guides"); });
  }, [guideId, nav]);

  useEffect(() => {
    const block = (e) => e.preventDefault();
    document.addEventListener("contextmenu", block);
    document.addEventListener("copy", block);
    return () => {
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("copy", block);
    };
  }, []);

  if (!guide) return <Layout><div className="p-10">Caricamento…</div></Layout>;
  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-6 lg:px-10 py-16 guide-protect">
        <div className="label-mono text-[#002FA7] mb-4">— Guida Premium</div>
        <h1 className="text-5xl font-black tracking-tighter leading-none mb-4">{guide.title}</h1>
        <p className="text-slate-500 italic mb-12">{guide.subtitle}</p>
        <div className="space-y-10">
          {guide.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display font-bold text-2xl mb-3">{i + 1}. {s.h}</h2>
              <p className="text-slate-700 leading-loose text-base">{s.p}</p>
            </section>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-slate-200">
          <div className="border border-[#002FA7] bg-[#0A0F1A] text-white p-8 premium-grain flex flex-col md:flex-row md:items-center justify-between gap-5">
            <div>
              <div className="label-mono text-[#FFD700] mb-2">Metti in pratica il metodo</div>
              <p className="text-slate-200 max-w-md leading-relaxed">Allenati sulle 450 domande con spiegazione in stile EPSO AD5 con la banca completa «Pro» o «Superiore».</p>
            </div>
            <Link to="/pricing"><Button data-testid="guide-cta-buy" className="rounded-none bg-[#FFD700] hover:bg-white text-[#0A0F1A] label-mono py-6 px-8 whitespace-nowrap">Acquista le domande</Button></Link>
          </div>
        </div>
        <div className="mt-8 text-xs text-slate-400 label-mono">© EU Logic Lab — Contenuto protetto. Copia, download e stampa disabilitati.</div>
        <div className="mt-4"><Link to="/guides" className="text-sm underline text-[#002FA7]">← Torna alle guide</Link></div>
      </article>
    </Layout>
  );
}
